const NAMESPACE = "energystoragemodelpicker";

const KEYS = {
    selectElementPromptText: "selectElementPromptText",
    noModelsToSelectPromptTemplate: "noModelsToSelectPromptTemplate",
    quantityAbbreviation: "quantityAbbreviation",
    quantityRequiredValidatorMessage: "quantityRequiredValidatorMessage",
    quantityPositiveValidatorMessage: "quantityPositiveValidatorMessage",
    manfAndModelRequiredValidatorMessage: "manfAndModelRequiredValidatorMessage",
    manfAltLabel: "manfAltLabel",
    modelAltLabel: "modelAltLabel",
    componentCloneButtonLabel: "componentCloneButtonLabel",
    iesEnergyRatingLabel: "iesEnergyRatingLabel",
    inverterRatingLabel: "inverterRatingLabel",
    batteryRatingLabel: "batteryRatingLabel",
    iesPowerRatingLabel: "iesPowerRatingLabel",
    batteryTechnologyLabel: "batteryTechnologyLabel",
    manufModelMismatchDialogTitle: "manufModelMismatchDialogTitle",
    manufModelMismatchDialogText: "manufModelMismatchDialogText",
    modelPowerUnitKilowatt: "modelPowerUnitKilowatt",
    modelPowerUnitKilowattHour: "modelPowerUnitKilowattHour"
};

const MESSAGES = {
    [KEYS.selectElementPromptText]: {
        value: "Please select...",
        comment: "Initial value for select elements before an item has been chosen"
    },
    [KEYS.noModelsToSelectPromptTemplate]: {
        value: "No active models found for this manufacturer",
        comment: "Prompt template to use when no models are found for the selected manufacturer"
    },
    [KEYS.quantityAbbreviation]: {
        value: "Qty",
        comment: "Abbreviation for quantity input field"
    },
    [KEYS.quantityRequiredValidatorMessage]: {
        value: "Please fill in quantity.",
        comment: "Error message for when quantity field is left blank"
    },
    [KEYS.quantityPositiveValidatorMessage]: {
        value: "Quantity must be an integer greater than 0.",
        comment: "Error message for when quantity field does not contain a positive integer"
    },
    [KEYS.manfAndModelRequiredValidatorMessage]: {
        value: "Please select manufacturer and model.",
        comment: "Error message for when manufacturer and model have not been selected"
    },
    [KEYS.manfAltLabel]: {
        value: "Manufacturer",
        comment: "Alt label for manufacturer dropdown"
    },
    [KEYS.modelAltLabel]: {
        value: "Model",
        comment: "Alt label for model dropdown"
    },
    [KEYS.componentCloneButtonLabel]: {
        value: "Clone",
        comment: "Label for button to make a clone of a component"
    },
    [KEYS.iesEnergyRatingLabel]: {
        value: "Nameplate Energy Capacity (Storage):",
        comment:
            "Label for the energy rating of the chosen integrated energy storage system model. Shown below the model picker."
    },
    [KEYS.iesPowerRatingLabel]: {
        value: "Maximum Continuous Discharge Rate:",
        comment:
            "Label for the power rating of the chosen integrated energy storage system model. Shown below the model picker."
    },
    [KEYS.inverterRatingLabel]: {
        value: "Maximum Continuous Output Power:",
        comment: "Label for the power rating of the chosen inverter model. Shown below the model picker."
    },
    [KEYS.batteryRatingLabel]: {
        value: "Nameplate Energy Capacity (Storage):",
        comment: "Label for the energy rating displayed for the chosen battery model.  Shown below the model picker."
    },
    [KEYS.batteryTechnologyLabel]: {
        value: "Battery Technology:",
        comment: "Label for the battery technology for the chosen model. Shown below the model picker."
    },
    [KEYS.manufModelMismatchDialogTitle]: {
        value: "Model Selection Error",
        comment: "Title for the dialog displayed when a manufacturer-model mismatch occurs."
    },
    [KEYS.manufModelMismatchDialogText]: {
        value:
            "The selected model does not belong to the manufacturer selected." +
            " The model option list has been repopulated, and you should make another selection.",
        comment: "Message text in the dialog displayed when a manufacturer-model mismatch occurs."
    },
    [KEYS.modelPowerUnitKilowatt]: {
        value: "kW",
        comment: "Unit for power rating of model"
    },
    [KEYS.modelPowerUnitKilowattHour]: {
        value: "kWh",
        comment: "Unit for energy rating of model"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
